module.exports = __webpack_public_path__ + "img/choose_course_back.68d74f11.png";